import React, { useState } from "react";
import Table from "./Table";
// import skeletonLoading from "../../assets/svgs/chat-thread.svg";
//import { formatTierName } from '../../utils/helpers';
import Icon from "../Icon";
import { dateFormat } from "../../utils/helper";
const ResellerTable = ({ data, setSelectedRow, setShowModal }) => {
  // Define columns based on category
  const columns = ["NAME", "EMAIL", "DATE", "STATUS"];

  const fmtStatus = (status) => {
    if (status === "ACCEPTED") {
      return "Accepted";
    } else if (status === "IN_REVIEW") {
      return "Review";
    } else if (status === "PENDING") {
      return "Pending";
    } else if (status === "TERMINATED") {
      return "Terminated";
    } else {
      return "Pending";
    }
  };

  return (
    <div>
      {!data?.length ? (
        <div className="emptyClients">
          <div className="noEmployee__container">
            {/* <img src={skeletonLoading} alt="loading" className="mt-[24px]" /> */}
            <h4 className="mt-[24px]">No Resellers Found</h4>
          </div>
        </div>
      ) : (
        <Table columns={columns} blueHeader={true}>
          <>
            {data?.flatMap((row) => (
              <tr
                className="pointer grey-bg"
                key={`${row.id}`}
                onClick={() => {
                  setSelectedRow(row);
                  setShowModal(true);
                }}
              >
                <td className="plan-table">{row?.resellerName}</td>
                <td className="plan-table">{row?.providerEmail}</td>
                <td className="plan-table">
                  {dateFormat(row?.dateCreated, "MMM dd, yyyy " || "--")}
                </td>
                <td className="plan-table">
                  <div
                    className={`${
                      row?.status === "ACCEPTED"
                        ? "bg-[#EBF7EE] text-[#3BAD54]"
                        : row?.status === "IN_REVIEW"
                        ? "bg-[#029AFF1A] text-[#029AFF]"
                        : row?.status === "TERMINATED"
                        ? "bg-[#FEE2E2] text-[#DC2626]"
                        : "bg-[#E68F001A] text-[#E68F00]"
                    }  px-[22px] py-[8px] font-[600] text-[12px] tracking-[2%] rounded-full  uppercase text-center`}
                  >
                    {fmtStatus(row?.status)}
                  </div>
                </td>
              </tr>
            ))}
          </>
        </Table>
      )}
    </div>
  );
};

export default ResellerTable;
